module.exports = __webpack_public_path__ + "static/media/wateruser-agriculture.c58ea3d4.png";